export const environment = {
  production: true,
  defaultauth: 'firebase',
  cf_base: 'https://us-central1-fitlego-e1026.cloudfunctions.net',
  challenge_cf_base: 'https://tracker.fitlego.com/login/',
  firebaseConfig: {
    apiKey: 'AIzaSyBJWD3_7vSAjAZ6k0-zK50Sh7I2Yv7NKU8',
    authDomain: 'fitlego-e1026.firebaseapp.com',
    databaseURL: 'https://fitlego-e1026-default-rtdb.firebaseio.com',
    projectId: 'fitlego-e1026',
    storageBucket: 'fitlego-e1026.appspot.com',
    messagingSenderId: '845229506812',
    appId: '1:845229506812:web:a2a6962517ce9066ea1779',
    measurementId: 'G-BVVMFWDTBN'
  }
};
